import React from "react";

import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";

import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import EditIcon from "@mui/icons-material/Edit";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTheme } from "@mui/material/styles";
import { DeleteDialog } from "../components/DeleteDialog";

import TextField from "@mui/material/TextField";

import IconButton from "@mui/material/IconButton";

const Task = ({
  title,
  description,
  assignedTo,
  details,
  due,
  id,
  canEdit,
  openEdit,
  handleDelete,
  isOtherUser = false,
}) => {
  const theme = useTheme();
  const [expanded, setExpanded] = React.useState(false);
  const [confirmOpen, setConfirmOpen] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  const handleConfirmOpen = () => {
    setConfirmOpen(true);
  };

  const handleConfirmDelete = () => {
    handleDelete(id);
    setConfirmOpen(false);
  };
  
  return (
    <>
      <Card sx={{
        width: 270, backgroundColor: isOtherUser
          ? theme.palette.grey[300]
          : theme.palette.background.paper,
      }}>
        <CardHeader title={title} subheader={description} />
        <CardActions disableSpacing>
          <IconButton
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
             color="primary"
          >
            <ExpandMoreIcon />
          </IconButton>

          {canEdit && (
            <>
              {typeof openEdit === "function" && (
                <IconButton
                  onClick={() =>
                    openEdit({ title, description, assignedTo, details, due, id })
                  }
                  aria-label="edit"
                   color="primary"
                >
                  <EditIcon />
                </IconButton>
              )}
              {typeof handleDelete === "function" && (
                <IconButton
                  onClick={handleConfirmOpen}
                  aria-label="delete"
                  color="primary"                >
                  <DeleteIcon />
                </IconButton>
              )}
            </>
          )}

        </CardActions>
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <CardContent>
            <TextField
              label="Details"
              multiline
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              fullWidth
              margin="normal"
              value={details}
            />
            {assignedTo && (
              <TextField
                label="Assigned to"
                InputProps={{ readOnly: true }}
                InputLabelProps={{ shrink: true }}
                variant="outlined"
                fullWidth
                margin="normal"
                value={assignedTo}
              />
            )}
            <TextField
              label="Due date"
              InputProps={{
                readOnly: true,
              }}
              InputLabelProps={{ shrink: true }}
              variant="outlined"
              fullWidth
              margin="normal"
              value={due}
            />
          </CardContent>
        </Collapse>
      </Card>
      <DeleteDialog
        identifier={title}
        title="Delete Task?"
        open={confirmOpen}
        setDialogOpen={setConfirmOpen}
        confirmDelete={handleConfirmDelete}
      ></DeleteDialog>
    </>
  );
};

export default Task;
